var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.86364C0.5 1.11052 1.11052 0.5 1.86364 0.5H14.1364C14.8895 0.5 15.5 1.11052 15.5 1.86364V14.1364C15.5 14.8895 14.8895 15.5 14.1364 15.5H1.86364C1.11052 15.5 0.5 14.8895 0.5 14.1364V1.86364ZM13 3C13 2.53976 12.6269 2.16667 12.1667 2.16667H3.83333C3.3731 2.16667 3 2.53976 3 3V13C3 13.4602 3.3731 13.8333 3.83333 13.8333H12.1667C12.6269 13.8333 13 13.4602 13 13V12.1667H12.1667V12.5833C12.1667 12.8135 11.9801 13 11.75 13H4.25C4.01988 13 3.83333 12.8135 3.83333 12.5833V3.41667C3.83333 3.18655 4.01988 3 4.25 3H11.75C11.9801 3 12.1667 3.18655 12.1667 3.41667V3.83333H13V3ZM11.3333 8.83333V11.3333L14.6667 8L11.3333 4.66667V7.16667H7.16667V8.83333H11.3333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.d1de34a9fdb6aede1edb83e8be5db74c.svg";
export { ForwardRef as ReactComponent };